// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-row {
  display: flex;
  gap: 20px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content {
  width: 612px;
  flex-shrink: 0;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card {
  height: 100%;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner {
  padding: 16px;
  height: 100%;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner.card-inner--column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}


.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status {
  height: 16px;
  width: 34px;
  margin-right: 8px;
  display: inline-flex;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {
  width: 34px;
  height: 16px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {
  width: 16px;
  height: 16px;
  transform: translateX(0);
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Table {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Cell:first-child {
  width: 45%;
  white-space: wrap;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Cell:last-child {
  width: 55%;
  white-space: wrap;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__TableRow:nth-child(odd) {
  background-color: #FAFBFB;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide {
  margin-bottom: 8px;
  margin-top: 16px;
  text-align: left;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide .Polaris-Link {
  display: inline-flex;
  align-items: center;
  text-decoration: underline;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide .Polaris-Link .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
  margin-left: 2px;
}


.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Navigation {
  display: none;
}

.BC-Page.BC-Page__KlaviyoIntegration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.BC-Page.BC-Page__KlaviyoIntegration .BC-Page__Title--Help {
  padding-left: 53px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .divider {
  border: 1px solid #E1E3E5;
  margin-bottom: 24px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 12px 16px;
  background: #FAFBFB;
  border: 1px solid transparent;
  border-radius: 4px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item:hover {
  border: 1px solid #1F5199;
  background: #EDF4FE;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item__title {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .text-ai {
  background: linear-gradient(135.64deg, #C830E1 16.99%, #FE4A25 84.55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
}


.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .Polaris-Badge {
  background: #FF30001A;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .Polaris-Badge>span {
  display: flex;
  align-items: center;
  gap: 2px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .Polaris-ButtonGroup {
  flex-shrink: 0;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .Polaris-ButtonGroup .Polaris-ButtonGroup__Item:first-child .Polaris-Button {
  padding: 5px;
  min-width: 30px;
  min-height: 30px;
  width: 30px;
  height: 30px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .Polaris-ButtonGroup .Polaris-ButtonGroup__Item:last-child .Polaris-Button {
  padding: 5px 12px;
  width: 78px;
  height: 30px;
  min-height: 30px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .text-coming-soon {
  font-weight: 600;
  font-size: 16px;
  margin: 2px 0;
  line-height: 24px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .card-inner--center {
  text-align: center;
  padding-bottom: 20px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__toggle {
  background-color: #FAFBFB;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-wrapper:first-child .klaviyo-event-collapse__toggle {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-wrapper:last-child .klaviyo-event-collapse__toggle {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 0;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content .klaviyo-event-collapse__content__title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-basis: 50%;
  padding-left: 24px;
}

.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content p {
  flex-basis: 50%;
  text-align: left;
}

.BC-Page.BC-Page__KlaviyoIntegration~#PolarisPortalsContainer .Polaris-Modal-Dialog--sizeLarge {
  max-width: 1015px;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__flex {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__flex .BC-Checkbox-Status {
  margin-right: 0;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction {
  padding-left: 42px;
  margin-top: 4px;
  color: rgb(109, 113, 117);
  display: flex;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Link {
  display: inline-flex;
  margin-left: 4px;
  text-decoration: underline;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Icon {
  margin: 0;
  width: 18px;
  height: 18px;
  margin-left: 2px;
}

.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Icon .Polaris-Icon__Svg {
  fill: rgb(44, 110, 203);
}

.klaviyo-preview-modal {
  display: flex;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline {
  width: 620px;
  padding: 20px;
  border-right: 1px solid #E1E3E5;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .title-section {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .Polaris-Link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .feed-name {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: 4px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .feed-name .Polaris-Badge--statusInfo {
  background-color: #E0F0FF;
  color: #00527C;
  font-weight: 500;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .Polaris-Icon {
  margin: 0;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .guide-content .Polaris-Icon .Polaris-Icon__Svg {
  fill: #2C6FCD;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Icon .Polaris-Icon__Svg {
  fill: #8C9196;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Icon:hover .Polaris-Icon__Svg {
  fill: rgb(26, 28, 29);
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__actions .Polaris-ButtonGroup {
  gap: 20px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__actions .Polaris-ButtonGroup__Item {
  margin: 0;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code {
  max-height: 414px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code p {
  white-space: pre-wrap;
  max-width: 97%;
  margin-top: -24px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Button {
  position: sticky;
  top: 0;
  left: 100%;
  transform: translate(-50%, 0);
  padding: 0;
  width: 16px;
  height: 16px;
  min-width: unset;
  min-height: unset;
}

.klaviyo-preview-modal .loading-sync {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content {
  flex: 1;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .title-preview {
  padding: 12px;
  width: 100%;
  border-bottom: 1px solid #E1E3E5;
  text-align: center;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content {
  padding: 16px 20px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content--AI {
  overflow: hidden;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content .title-type {
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 16px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item {
  width: calc(50% - 10px);
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail {
  margin-bottom: 10px;
  text-align: center;
  aspect-ratio: 1;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail img {
  max-width: 100%;
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__title {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: rgb(32, 34, 35);
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__price-wrapper {
  text-align: center;
  margin-top: 6px;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__price {
  font-weight: 500;
  color: #6D7175;
  text-align: center;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__compare-price {
  color: #9B9B9B;
  text-decoration: line-through;
  margin-left: 6px
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail .Polaris-SkeletonThumbnail {
  max-width: 100%;
  height: 100%;
  width: 100%;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info .Polaris-SkeletonDisplayText__DisplayText {
  width: 100%;
  margin: auto;
  height: 20px;
  max-width: 6.5rem;
}

.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info>.Polaris-SkeletonDisplayText__DisplayText {
  max-width: 8rem;
  height: 24px;
}

.callback-klaviyo {
  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;
  background-color: #fff;
  border-radius: 8px;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.callback-klaviyo .callback-klaviyo__title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/styles/klaviyo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;EACtE,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iEAAiE;EACjE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-row {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content {\n  width: 612px;\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card {\n  height: 100%;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner {\n  padding: 16px;\n  height: 100%;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner.card-inner--column {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status {\n  height: 16px;\n  width: 34px;\n  margin-right: 8px;\n  display: inline-flex;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {\n  width: 34px;\n  height: 16px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {\n  width: 16px;\n  height: 16px;\n  transform: translateX(0);\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Table {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Cell:first-child {\n  width: 45%;\n  white-space: wrap;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Cell:last-child {\n  width: 55%;\n  white-space: wrap;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__TableRow:nth-child(odd) {\n  background-color: #FAFBFB;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide {\n  margin-bottom: 8px;\n  margin-top: 16px;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: underline;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .guide .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  margin-left: 2px;\n}\n\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .BC-Page__Title--Help {\n  padding-left: 53px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .divider {\n  border: 1px solid #E1E3E5;\n  margin-bottom: 24px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 32px;\n  padding: 12px 16px;\n  background: #FAFBFB;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item:hover {\n  border: 1px solid #1F5199;\n  background: #EDF4FE;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item__title {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .text-ai {\n  background: linear-gradient(135.64deg, #C830E1 16.99%, #FE4A25 84.55%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 600;\n}\n\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .Polaris-Badge {\n  background: #FF30001A;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .recommendation-item__title .Polaris-Badge>span {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .Polaris-ButtonGroup {\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .Polaris-ButtonGroup .Polaris-ButtonGroup__Item:first-child .Polaris-Button {\n  padding: 5px;\n  min-width: 30px;\n  min-height: 30px;\n  width: 30px;\n  height: 30px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .recommendation-item .Polaris-ButtonGroup .Polaris-ButtonGroup__Item:last-child .Polaris-Button {\n  padding: 5px 12px;\n  width: 78px;\n  height: 30px;\n  min-height: 30px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .text-coming-soon {\n  font-weight: 600;\n  font-size: 16px;\n  margin: 2px 0;\n  line-height: 24px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .card-inner--center {\n  text-align: center;\n  padding-bottom: 20px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__toggle {\n  background-color: #FAFBFB;\n  padding: 12px 16px;\n  display: flex;\n  gap: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-wrapper:first-child .klaviyo-event-collapse__toggle {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-wrapper:last-child .klaviyo-event-collapse__toggle {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom: 0;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content .klaviyo-event-collapse__content__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-basis: 50%;\n  padding-left: 24px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .klaviyo-container .klaviyo-col-content .klaviyo-event .klaviyo-event-collapse__content p {\n  flex-basis: 50%;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration~#PolarisPortalsContainer .Polaris-Modal-Dialog--sizeLarge {\n  max-width: 1015px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__flex {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__flex .BC-Checkbox-Status {\n  margin-right: 0;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction {\n  padding-left: 42px;\n  margin-top: 4px;\n  color: rgb(109, 113, 117);\n  display: flex;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Link {\n  display: inline-flex;\n  margin-left: 4px;\n  text-decoration: underline;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Icon {\n  margin: 0;\n  width: 18px;\n  height: 18px;\n  margin-left: 2px;\n}\n\n.BC-Page.BC-Page__KlaviyoIntegration .card-inner__instruction .Polaris-Icon .Polaris-Icon__Svg {\n  fill: rgb(44, 110, 203);\n}\n\n.klaviyo-preview-modal {\n  display: flex;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline {\n  width: 620px;\n  padding: 20px;\n  border-right: 1px solid #E1E3E5;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .title-section {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  margin-bottom: 8px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .feed-name {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  gap: 4px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .feed-name .Polaris-Badge--statusInfo {\n  background-color: #E0F0FF;\n  color: #00527C;\n  font-weight: 500;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .Polaris-Icon {\n  margin: 0;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .guide-content .Polaris-Icon .Polaris-Icon__Svg {\n  fill: #2C6FCD;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Icon .Polaris-Icon__Svg {\n  fill: #8C9196;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Icon:hover .Polaris-Icon__Svg {\n  fill: rgb(26, 28, 29);\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__actions .Polaris-ButtonGroup {\n  gap: 20px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .klaviyo-preview-modal__actions .Polaris-ButtonGroup__Item {\n  margin: 0;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code {\n  max-height: 414px;\n  overflow: auto;\n  scrollbar-width: thin;\n  scrollbar-gutter: stable;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code p {\n  white-space: pre-wrap;\n  max-width: 97%;\n  margin-top: -24px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__guideline .code .Polaris-Button {\n  position: sticky;\n  top: 0;\n  left: 100%;\n  transform: translate(-50%, 0);\n  padding: 0;\n  width: 16px;\n  height: 16px;\n  min-width: unset;\n  min-height: unset;\n}\n\n.klaviyo-preview-modal .loading-sync {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content {\n  flex: 1;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .title-preview {\n  padding: 12px;\n  width: 100%;\n  border-bottom: 1px solid #E1E3E5;\n  text-align: center;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content {\n  padding: 16px 20px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content--AI {\n  overflow: hidden;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .preview-content .title-type {\n  font-weight: 600;\n  font-size: 20px;\n  text-transform: uppercase;\n  line-height: 32px;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 20px;\n  row-gap: 16px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item {\n  width: calc(50% - 10px);\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail {\n  margin-bottom: 10px;\n  text-align: center;\n  aspect-ratio: 1;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail img {\n  max-width: 100%;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  object-position: center;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__title {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  color: rgb(32, 34, 35);\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__price-wrapper {\n  text-align: center;\n  margin-top: 6px;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__price {\n  font-weight: 500;\n  color: #6D7175;\n  text-align: center;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info__compare-price {\n  color: #9B9B9B;\n  text-decoration: line-through;\n  margin-left: 6px\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__thumbnail .Polaris-SkeletonThumbnail {\n  max-width: 100%;\n  height: 100%;\n  width: 100%;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info .Polaris-SkeletonDisplayText__DisplayText {\n  width: 100%;\n  margin: auto;\n  height: 20px;\n  max-width: 6.5rem;\n}\n\n.klaviyo-preview-modal .klaviyo-preview-modal__preview-content .product-container .product-item .product-item__info>.Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 8rem;\n  height: 24px;\n}\n\n.callback-klaviyo {\n  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 40px 48px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.callback-klaviyo .callback-klaviyo__title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  text-align: center;\n  margin-top: 12px;\n  margin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
